import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbMenuModule } from '@nebular/theme';
import { ThemeModule } from '../../@theme/theme.module';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

import {
  NbActionsModule,
  NbButtonModule,
  NbCardModule,
  NbIconModule,
  NbInputModule,
  NbRadioModule,
  NbSelectModule,
  NbListModule,
  NbUserModule,
  NbDialogModule,
  NbFormFieldModule,
  NbSpinnerModule
} from '@nebular/theme';

import { UserComponent } from './user.component';
import { UserRoutingModule } from './user-routing.module';
import { LoginComponent } from './login/login.component';

import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { ToolModule } from '../../tool/tool.module'



@NgModule({
  imports: [
    NgxQRCodeModule,
    CommonModule,
    UserRoutingModule,
    ThemeModule,
    NbInputModule,
    NbCardModule,
    NbButtonModule,
    NbActionsModule,
    NbUserModule,
    NbMenuModule,
    NbDialogModule.forChild(),
    NbIconModule,
    NbRadioModule,
    NbSelectModule,
    NbListModule,
    FormsModule,
    ReactiveFormsModule,
    NbFormFieldModule,
    ToolModule,
    NbSpinnerModule
  ],
  declarations: [
    UserComponent,
    LoginComponent,
  ],
  providers: [
   
  ],
  entryComponents: [
    
  ],
})
export class UserModule {
}
